import React from 'react';
import DownloadCsvButton from '../DownloadCsvButton';
import { exportProductsToCsv } from '../../../services/productsCsvExportService';

const DownloadProductsCsvButton = () => (
    <DownloadCsvButton
        labelKey="app.page.product.downloadCSV"
        onExport={exportProductsToCsv}
    />
);

export default DownloadProductsCsvButton;
